var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 9.0002C13.2 8.55837 13.5581 8.2002 14 8.2002H20C20.4418 8.2002 20.8 8.55837 20.8 9.0002C20.8 9.44202 20.4418 9.80019 20 9.80019H14C13.5581 9.80019 13.2 9.44202 13.2 9.0002Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 13.0002C13.2 12.5584 13.5581 12.2002 14 12.2002H20C20.4418 12.2002 20.8 12.5584 20.8 13.0002C20.8 13.442 20.4418 13.8002 20 13.8002H14C13.5581 13.8002 13.2 13.442 13.2 13.0002Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 17.0002C13.2 16.5584 13.5581 16.2002 14 16.2002H20C20.4418 16.2002 20.8 16.5584 20.8 17.0002C20.8 17.442 20.4418 17.8002 20 17.8002H14C13.5581 17.8002 13.2 17.442 13.2 17.0002Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96184 14.5401C4.457 14.0096 5.14087 13.7002 5.86662 13.7002H9.13328C9.85904 13.7002 10.5429 14.0096 11.0381 14.5401C11.5315 15.0688 11.8 15.7747 11.8 16.5002V17.5002C11.8 17.942 11.4418 18.3002 11 18.3002H3.99995C3.55812 18.3002 3.19995 17.942 3.19995 17.5002V16.5002C3.19995 15.7747 3.46842 15.0688 3.96184 14.5401ZM5.86662 15.3002C5.60223 15.3002 5.3365 15.4122 5.13153 15.6318C4.92481 15.8533 4.79995 16.1648 4.79995 16.5002V16.7002H10.2V16.5002C10.2 16.1648 10.0751 15.8533 9.86837 15.6318C9.6634 15.4122 9.39767 15.3002 9.13328 15.3002H5.86662Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70005 10.0002C8.70005 9.33745 8.16279 8.8002 7.50005 8.8002C6.83731 8.8002 6.30005 9.33745 6.30005 10.0002C6.30005 10.6629 6.83731 11.2002 7.50005 11.2002C8.16279 11.2002 8.70005 10.6629 8.70005 10.0002ZM7.50005 7.2002C9.04645 7.2002 10.3 8.4538 10.3 10.0002C10.3 11.5466 9.04645 12.8002 7.50005 12.8002C5.95365 12.8002 4.70005 11.5466 4.70005 10.0002C4.70005 8.4538 5.95365 7.2002 7.50005 7.2002Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99993 1.2002C8.00582 1.2002 7.19993 2.00608 7.19993 3.0002V3.20019H2.99995C1.45355 3.20019 0.199951 4.45379 0.199951 6.00019V18.0002C0.199951 19.5466 1.45355 20.8002 2.99995 20.8002H21C22.5463 20.8002 23.7999 19.5466 23.7999 18.0002V6.00019C23.7999 4.45379 22.5463 3.20019 21 3.20019H16.7999V3.0002C16.7999 2.00608 15.994 1.2002 14.9999 1.2002H8.99993ZM16.7999 4.80019V5.0002C16.7999 5.99431 15.994 6.8002 14.9999 6.8002H8.99993C8.00582 6.8002 7.19993 5.99431 7.19993 5.0002V4.80019H2.99995C2.33721 4.80019 1.79995 5.33744 1.79995 6.00019V18.0002C1.79995 18.6629 2.33721 19.2002 2.99995 19.2002H21C21.6627 19.2002 22.2 18.6629 22.2 18.0002V6.00019C22.2 5.33744 21.6627 4.80019 21 4.80019H16.7999ZM8.79993 3.0002C8.79993 2.88974 8.88947 2.8002 8.99993 2.8002H14.9999C15.1104 2.8002 15.1999 2.88974 15.1999 3.0002V5.0002C15.1999 5.11065 15.1104 5.2002 14.9999 5.2002H8.99993C8.88947 5.2002 8.79993 5.11065 8.79993 5.0002V3.0002Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.45c3546cc47b6fd4ced4e81a15032248.svg";
export { ForwardRef as ReactComponent };